// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'dimension.page.title': 'Dimensions',
    'dimension.page.archive.title': 'Archived Dimensions',
    'dimension.page.search_results': 'Search Results',
    'dimension.page.create.title': 'Create New Dimension',
    'dimension.page.search.title': 'Find Dimensions',
    'dimension.page.edit.title': 'Edit Dimension',
    'dimension.page.all': 'All',

    'dimension.button.cancel': 'Cancel',
    'dimension.button.select': 'Select',
    'dimension.button.find': 'Find Dimensions',
    'dimension.button.search': 'Apply',
    'dimension.button.create': 'Save Dimension',
    'dimension.button.new': 'New Dimension',
    'dimension.button.save': 'Save Changes',
    'dimension.button.archive': 'Archive',
    'dimension.button.edit': 'Edit',
    'dimension.button.restore': 'Restore',
    'dimension.button.reset': 'Reset',
    'dimension.button.filter': 'Filter',
    'dimension.button.sort': 'Sort',
    'dimension.button.add_value': 'Add Value',

    'dimension.placeholder.search': 'Search dimensions',
    'dimension.placeholder.select_value': 'Select a value',

    'dimension.link.create_first_dimension': 'Click here to create your first dimension',
    'dimension.link.dimensions': ' Return to Dimensions',
    'dimension.link.archive': 'Archived Dimensions',
    'dimension.link.retry': 'Click here to retry',

    'dimension.checkbox.all': 'Check All',
    'dimension.checkbox.actions_label': 'with selected',

    'dimension.label.dimension_code': 'Dimension Code',
    'dimension.label.dimension_name': 'Dimension Name',
    'dimension.label.description': 'Description',
    'dimension.label.required': 'Required',
    'dimension.label.is_required': 'Required',
    'dimension.label.is_active': 'Active',
    'dimension.label.dimension_values': 'Dimension Values',
    'dimension.label.value_code': 'Value Code',
    'dimension.label.value_name': 'Value Name',
    'dimension.label.parent_value': 'Parent Value',

    'dimension.sort.field_label': 'Field',
    'dimension.sort.direction_label': 'Direction',
    'dimension.sort.direction_ascending': 'Ascending',
    'dimension.sort.direction_descending': 'Descending',

    'dimension.modal.title.dimension_archive': 'Archive Dimension',
    'dimension.modal.title.dimension_restore': 'Restore Dimension',
    'dimension.modal.title.add_value': 'Add Dimension Value',
    'dimension.modal.title.edit_value': 'Edit Dimension Value',
    'dimension.modal.title.dimension_value_archive': 'Archive Dimension Value',

    'dimension.modal.message.dimension_archive': 'Are you sure that you want to move this dimension to the archive? | Are you sure that you want to move these dimensions to the archive?',
    'dimension.modal.message.dimension_restore': 'Are you sure that you want to restore this dimension? | Are you sure that you want to restore these dimensions?',
    'dimension.modal.message.dimension_value_archive': 'Are you sure that you want to archive this dimension value?',

    'dimension.success.message.dimension_created': 'Your dimension has been created',
    'dimension.success.message.dimension_updated': 'Your dimension has been updated',
    'dimension.success.message.dimension_archived': 'Your dimension was moved to the archive | All selected dimensions were moved to the archive',
    'dimension.success.message.dimension_restored': 'Your dimension has been restored | All selected dimensions were restored',
    'dimension.success.message.dimension_value_created': 'Your dimension value has been created',
    'dimension.success.message.dimension_value_updated': 'Your dimension value has been updated',
    'dimension.success.message.dimension_value_archived': 'Your dimension value was moved to the archive | All selected dimension values were moved to the archive',

    'dimension.error.message.dimension_archived': 'This dimension was already moved to the archive | These dimensions were already moved to the archive',
    'dimension.error.message.dimension_restored': 'This dimension was already restored | These dimensions were already restored',
    'dimension.error.message.error_loading_page': 'Sorry, there was an error loading dimension.| Sorry, there was an error loading dimensions.',

    'dimension.message.search.no_archived_dimensions': "You haven't archived any dimensions as yet.",
    'dimension.message.search.no_dimension_values': 'No dimension values have been created yet.',
};
